import React, {useEffect} from 'react';
import {useLocation} from 'react-router-dom';
import {useSelector} from 'react-redux';
import renderPopup from '../../../helpers/renderPopup';
import CheckoutSuccess from './CheckoutSuccess';
import CheckoutCancel from './CheckoutCancel';
import SubscriptionCheckoutSuccess from './SubscriptionCheckoutSuccess';
import PopupBase from '../PopupBase';
import utilities from '../../../utilities/utilities';

function clearCheckoutParamsFromUrl() {
  sessionStorage.removeItem('stripeCheckoutUrl');
  const newUrl = new URL(window.location.href);
  newUrl.searchParams.delete('success_session_id');
  newUrl.searchParams.delete('cancel_session_id');
  newUrl.searchParams.delete('checkout_type');
  window.history.replaceState({}, '', newUrl.toString());
}

const StripeCheckoutCompleteHandler = () => {
  const location = useLocation();
  const userData = useSelector(state => state.user.userData);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const successSessionId = params.get('success_session_id');
    const cancelSessionId = params.get('cancel_session_id');
    const checkoutType = params.get('checkout_type');

    if (successSessionId || cancelSessionId) {
      // After logout, user is anonymous; don't show checkout popup and clear params so it won't show on refresh.
      if (!utilities.isLoggedIn(userData)) {
        clearCheckoutParamsFromUrl();
        return;
      }

      const isSuccess = !!successSessionId;
      const sessionId = successSessionId || cancelSessionId;
      const isSubscription = checkoutType === 'subscription';

      let popupContent;
      if (isSuccess) {
        popupContent = isSubscription ? <SubscriptionCheckoutSuccess /> : <CheckoutSuccess sessionId={sessionId} />;
      }
      else {
        popupContent = <CheckoutCancel sessionId={sessionId} />;
      }

      const popup = (
        <PopupBase
          title={isSuccess ? 'Payment Successful' : 'Payment Cancelled'}
          closeEvent={() => {
            clearCheckoutParamsFromUrl();
          }}
        >
          {popupContent}
        </PopupBase>
      );

      renderPopup(popup);
    }
  }, [location, location.search, userData]);

  return null;
};

export default StripeCheckoutCompleteHandler;
